var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { useTheme } from "../../ThemeProvider/ThemeProvider";
var getBorder = function (color, colorGradient) {
    return {
        default: "1px solid ".concat(colorGradient[color].accentScale[8]),
        hover: "1px solid ".concat(colorGradient[color].accentScale[9]),
        active: "1px solid ".concat(colorGradient[color].accentScale[9]),
    };
};
var StyledToggleBtnGroup = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  & > :first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n  & > :not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n  & > :not(:last-child) {\n    border-left: ", ";\n    border-top: ", ";\n    border-bottom: ", ";\n    border-right: 0;\n\n    &:hover {\n      border-left: ", ";\n      border-top: ", ";\n      border-bottom: ", ";\n    }\n\n    &:active {\n      border-left: ", ";\n      border-top: ", ";\n      border-bottom: ", ";\n    }\n  }\n  & > :last-child {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border: ", ";\n\n    &:hover {\n      border: ", ";\n    }\n    &:active {\n      border: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  & > :first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n  & > :not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n  & > :not(:last-child) {\n    border-left: ", ";\n    border-top: ", ";\n    border-bottom: ", ";\n    border-right: 0;\n\n    &:hover {\n      border-left: ", ";\n      border-top: ", ";\n      border-bottom: ", ";\n    }\n\n    &:active {\n      border-left: ", ";\n      border-top: ", ";\n      border-bottom: ", ";\n    }\n  }\n  & > :last-child {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border: ", ";\n\n    &:hover {\n      border: ", ";\n    }\n    &:active {\n      border: ", ";\n    }\n  }\n"])), function (props) { return props.$width; }, function (props) {
    return getBorder(props.$color, props.$colorGradient).default;
}, function (props) {
    return getBorder(props.$color, props.$colorGradient).default;
}, function (props) {
    return getBorder(props.$color, props.$colorGradient).default;
}, function (props) {
    return getBorder(props.$color, props.$colorGradient).hover;
}, function (props) {
    return getBorder(props.$color, props.$colorGradient).hover;
}, function (props) {
    return getBorder(props.$color, props.$colorGradient).hover;
}, function (props) {
    return getBorder(props.$color, props.$colorGradient).active;
}, function (props) {
    return getBorder(props.$color, props.$colorGradient).active;
}, function (props) {
    return getBorder(props.$color, props.$colorGradient).active;
}, function (props) { return getBorder(props.$color, props.$colorGradient).default; }, function (props) { return getBorder(props.$color, props.$colorGradient).hover; }, function (props) {
    return getBorder(props.$color, props.$colorGradient).active;
});
var getIndexFromValue = function (value, children) {
    var childrenArray = React.Children.toArray(children);
    return childrenArray.findIndex(function (child) { return child.props.value === value; });
};
var ToggleButtonGroup = function (_a) {
    var children = _a.children, value = _a.value, _b = _a.color, color = _b === void 0 ? "primary" : _b, className = _a.className, size = _a.size, style = _a.style, _c = _a.width, width = _c === void 0 ? "fit-content" : _c, 
    //Events
    onClick = _a.onClick;
    var _d = React.useState(value ? getIndexFromValue(value, children) : null), selectedIndex = _d[0], setSelectedIndex = _d[1];
    React.useEffect(function () {
        setSelectedIndex(value ? getIndexFromValue(value, children) : null);
    }, [value, children]);
    var colorPalette = useTheme().theme.colorPalette;
    var _onClick = function (e, value, index) {
        setSelectedIndex(index !== null && index !== void 0 ? index : null);
        onClick && onClick(e, value);
    };
    return (_jsx(StyledToggleBtnGroup, __assign({ "$width": width, "$color": color, "$colorGradient": colorPalette, className: className, style: style }, { children: React.Children.map(children, function (child, index) {
            if (React.isValidElement(child) && child.type) {
                var childElement = child;
                var childType = childElement.type;
                if (typeof childType === "string")
                    return child;
                /* causing an issue in production build as they define a custom name for the component */
                if (childType.displayName === "ToggleButton") {
                    return React.cloneElement(childElement, __assign(__assign({ index: index, selected: selectedIndex === index }, (!childElement.props.size && size && { size: size })), { onClick: _onClick }));
                }
            }
            return child;
        }) })));
};
export default ToggleButtonGroup;
var templateObject_1;
